import {gql} from 'apollo-angular';
import {ImageFragment} from "./Image";

export const ProfessionPreviewFragment = gql`
  fragment professionPreviewFields on Job {
    id
    bicID
    name
    jobEducationalPaths {
      id
      name
    }
    scholasticDuration {
      durationName
      position
    }
    requirementsByType {
      requirementTypes {
        requirementType {
          id
          bicID
          typeName
        }
        requirements {
          id
          bicID
        }
      }
    }
    image {
      ...imageFields
    }
    schoolSubjectMappings {
      jobSchoolSubject {
        id
      }
    }
    interestFields {
      id
    }
    jobLinkMappings {
      id
    }
    jobSalary {
      entryValue
    }
    jobRedirects {
        bicID
        jobName
        redirectType
    }
    jobWorkFields {
        name
        bicID
    }
  }
  ${ImageFragment}
`;
